import RadioBox from "app/radio/components/RadioBox"
import { usePlay } from "app/radio/components/PlayerContext"
import { useEffect } from "react"

export function RadioRouteGuard({ hideRadio }: { hideRadio: boolean }) {
  const { pause } = usePlay()

  useEffect(() => {
    if (hideRadio) {
      pause()
    }
  }, [hideRadio, pause])

  if (hideRadio) return null
  return <RadioBox />
}
